import { track } from '$lib/services/tracking/googleAnalytics';

export function trackActivateFullscreen() {
	track({
		action: 'chevron_button',
		payload: {
			action: 'activate',
		},
	});
}

export function trackDisableFullscreen() {
	track({
		action: 'chevron_button',
		payload: {
			action: 'disable',
		},
	});
}
